import React from "react";
import { Typography } from "@material-ui/core";
import { Promotion } from "../store/ComponentTexts";
import { PrimaryButton } from "./Buttons";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Theme } from "../.themes";

type PromoProps = Promotion & {
  className?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  spacers: {
    marginTop: theme.spacing(3),
  },
  header: {
    color: theme.palette.text.primary,
    ...theme.confirmationPageHeader,
  },
}));

export const PromotionBlock: React.FC<PromoProps> = (props: PromoProps) => {
  const css = useStyles();

  const shouldRender = props?.header || props?.body || (props?.link && props.link.text && props.link.url);

  if (!shouldRender) {
    return <React.Fragment />;
  }

  function handleClick() {
    if (props.link?.url) {
      window.top?.location.replace(props.link?.url.toString());
    }
  }

  return (
    <div className={props.className}>
      {props?.header && (
        <Typography variant='h5' className={clsx(css.spacers, css.header)}>
          {props.header}
        </Typography>
      )}
      {props?.body && (
        <Typography variant='body1' component='p' className={clsx(css.spacers)}>
          {props.body}
        </Typography>
      )}
      {props?.link && props.link.text && props.link.url && (
        <PrimaryButton fullWidth={true} onClick={handleClick} className={clsx(css.spacers)}>
          {props.link?.text}
        </PrimaryButton>
      )}
    </div>
  );
};
